/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OfferCell_offer$ref = any;
type OfferEdit_offer$ref = any;
export type UpdateOfferInput = {|
  clientMutationId?: ?string,
  description?: ?string,
  endDate?: ?any,
  finePrint?: ?string,
  id: string,
  isCheckIn: boolean,
  isFlash?: ?boolean,
  isLatest?: ?boolean,
  isPromoted?: ?boolean,
  isRedeemable?: ?boolean,
  isTop: boolean,
  redemptionCode?: ?string,
  startDate?: ?any,
  storeId?: ?string,
  title?: ?string,
|};
export type updateOfferMutationVariables = {|
  input: UpdateOfferInput
|};
export type updateOfferMutationResponse = {|
  +updateOffer: ?{|
    +offer: ?{|
      +store: {|
        +id: string
      |},
      +$fragmentRefs: OfferEdit_offer$ref & OfferCell_offer$ref,
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateOfferMutation = {|
  variables: updateOfferMutationVariables,
  response: updateOfferMutationResponse,
|};
*/


/*
mutation updateOfferMutation(
  $input: UpdateOfferInput!
) {
  updateOffer(input: $input) {
    offer {
      ...OfferEdit_offer
      ...OfferCell_offer
      store {
        id
      }
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment OfferCell_offer on Offer {
  id
  title
  description
  store {
    name
    id
  }
  imageUrl
  startDate
  endDate
  isFlash
  isLatest
  isPromoted
  isRedeemable
  isCheckIn
  redemptionCode
  finePrint
  isTop
  shareableUrl
  appUrl
}

fragment OfferEdit_offer on Offer {
  id
  title
  description
  store {
    id
  }
  imageUrl
  startDate
  endDate
  isFlash
  isLatest
  isPromoted
  isRedeemable
  isCheckIn
  redemptionCode
  finePrint
  isTop
  shareableUrl
  appUrl
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOfferInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOfferPayload",
        "kind": "LinkedField",
        "name": "updateOffer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Offer",
            "kind": "LinkedField",
            "name": "offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OfferEdit_offer"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OfferCell_offer"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOfferPayload",
        "kind": "LinkedField",
        "name": "updateOffer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Offer",
            "kind": "LinkedField",
            "name": "offer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFlash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLatest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPromoted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRedeemable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCheckIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "redemptionCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finePrint",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTop",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareableUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateOfferMutation",
    "operationKind": "mutation",
    "text": "mutation updateOfferMutation(\n  $input: UpdateOfferInput!\n) {\n  updateOffer(input: $input) {\n    offer {\n      ...OfferEdit_offer\n      ...OfferCell_offer\n      store {\n        id\n      }\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment OfferCell_offer on Offer {\n  id\n  title\n  description\n  store {\n    name\n    id\n  }\n  imageUrl\n  startDate\n  endDate\n  isFlash\n  isLatest\n  isPromoted\n  isRedeemable\n  isCheckIn\n  redemptionCode\n  finePrint\n  isTop\n  shareableUrl\n  appUrl\n}\n\nfragment OfferEdit_offer on Offer {\n  id\n  title\n  description\n  store {\n    id\n  }\n  imageUrl\n  startDate\n  endDate\n  isFlash\n  isLatest\n  isPromoted\n  isRedeemable\n  isCheckIn\n  redemptionCode\n  finePrint\n  isTop\n  shareableUrl\n  appUrl\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6d1bc956e614231609abca4595fde265';

module.exports = node;
